function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\u51CF\u53BB");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "C\\u7AEF",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu-cart",
  transform: "translate(-284.000000, -379.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-24"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-22",
  transform: "translate(16.000000, 343.500000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-21"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u52A0\\u51CF",
  transform: "translate(268.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u51CF\\u53BB"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u6DFB\\u52A0"
}, /*#__PURE__*/React.createElement("g", {
  id: "add-circular-outlined-button",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,0 C5.37223529,0 0,5.37223529 0,12 C0,18.6277647 5.37223529,24 12,24 C18.6277647,24 24,18.6269804 24,12 C24,5.37301961 18.6277647,0 12,0 Z M12,22.5 C6.20098039,22.5 1.5,17.7990196 1.5,12 C1.5,6.20098039 6.20098039,1.5 12,1.5 C17.7990196,1.5 22.5,6.20098039 22.5,12 C22.5,17.7990196 17.7990196,22.5 12,22.5 Z",
  id: "Shape",
  fill: "#DDDDDD"
}), /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  fill: "#C6CBD4",
  x: 7,
  y: 11,
  width: 10,
  height: 2
})))))))))));

const SvgDecrease = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "25px",
  viewBox: "0 0 24 25",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDecrease, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/decrease.26d5dbaa.svg";
export { ForwardRef as ReactComponent };